export default "__VITE_ASSET__D$WfSbYX__"